import React, { useState } from "react";
import SubscriptionDetailsModal from "./SubscriptionDetailsModal";

export default function SubscriptionDetailsIcon({
    email,
    user,
    orders,
    filters,
    filterOrders,
    sortedOrders,
    setSortConfig,
    onRefresh
}) {
    const [isOpen, setIsOpen] = useState(false);

    if (!email) return null;

    return (
        <>
            <i
                className="bx bx-receipt"
                title="View Subscriptions"
                style={{
                    cursor: "pointer",
                    fontSize: 15,
                    color: "#f0b429",
                    marginLeft: 10,
                }}
                onClick={() => setIsOpen(true)}
            ></i>

            {isOpen && (
                <SubscriptionDetailsModal
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    customerEmail={email}
                    orders={orders}
                    filters={filters}
                    filterOrders={filterOrders}
                    sortedOrders={sortedOrders}
                    setSortConfig={setSortConfig}
                    onRefresh={onRefresh}
                />
            )}
        </>
    );
}
